import apiConfig from '../config/api'
import { apiRequestorHelper } from '../helpers'

export default {
  getSIIActivities: (country) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/public/getAllActecosSII?country='+country,
      method: 'post',
    })
  },
}
